"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useThrottle", {
    get: ()=>_useThrottle.useThrottle,
    enumerable: true
});
const _useThrottle = require("./useThrottle");
